import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../../primitives';
import { NewProductVariantSchema } from '../new-product-variant-schema';
import { UsagePricingSchema } from './usage-pricing-schema';

export const NewUsageProductVariantSchema = NewProductVariantSchema
  .extend({
    meterId: oz.string({
      required_error: 'Meter ID is required',
    }).refine((value) => ObjectIdSchema.safeParse(value).success, {
      message: 'Invalid ObjectId',
    }),
    pricing: UsagePricingSchema,
  })
  .openapi('NewUsageProductVariant');

export type NewUsageProductVariant = oz.infer<typeof NewUsageProductVariantSchema>;